import { useState, useRef, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import DonationList from "../components/Donation/DonationList";
import { usePageLogger } from "../hooks/usePageLogger";
import SnackbarAlert from "../components/SnackBarAlert";
import DonationFormModal from "../components/Donation/DonationFormModal";
import * as donationHandlers from "../components/Donation/utils/donationHandlers";

const DonationManagement = ({ filterData }) => {
  const [open, setOpen] = useState(false);
  const [isopenNew, setIsOpenNew] = useState(false);
  const [editData, setEditData] = useState(null);
  const dispatch = useDispatch();
  const formRef = useRef();
  const [originalDonation, setOriginalDonation] = useState(null);
  const { user } = useSelector((state) => state.auth);
  const [feedback, setFeedback] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  useEffect(() => {
    if (filterData) {
      setEditData({
        transactionId: filterData.transactionId || "",
        donorId: filterData.donorId || "",
        payPurpose: filterData.payPurpose || "",
        tributeName: filterData.tributeName || "",
        tamilMonths: filterData.tamilMonths || "",
        nachathiram: filterData.nachathiram || "",
        thithi: filterData.thithi || "",
        utsavam: filterData.utsavam || "",
      });
    }
  }, [filterData]);

  usePageLogger("Donations Page", {
    username: user?.username,
    role: user?.role,
  });

  useEffect(() => {
    if (editData) {
      setOriginalDonation(editData);
    }
  }, [editData]);

  const handleEditDonation = useCallback((donation) => {
    donationHandlers.handleEditDonation(donation, setEditData, setOpen);
  }, []);

  const handleAddDonationData = useCallback((donor) => {
    donationHandlers.handleAddDonationData(donor, setEditData, setIsOpenNew);
  }, []);

  const handleCloseModalCallback = useCallback(() => {
    donationHandlers.handleCloseModal(setOpen, setIsOpenNew, setEditData);
  }, []);

  const handleCloseFeedbackCallback = useCallback(() => {
    donationHandlers.handleCloseFeedback(feedback, setFeedback);
  }, [feedback]);

  const handleSaveDonation = useCallback(
    async (data) => {
      await donationHandlers.handleSaveDonation(
        data,
        originalDonation,
        dispatch,
        user,
        setFeedback,
        handleCloseModalCallback
      );
    },
    [dispatch, originalDonation, user, handleCloseModalCallback]
  );

  return (
    <Box
      sx={{
        flexGrow: 1,
        padding: "24px",
        backgroundColor: "#f5f5f5",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {" "}
      <Typography variant="h4" gutterBottom>
        Donation Information
      </Typography>
      <DonationList
        onEdit={handleEditDonation}
        onAppend={handleAddDonationData}
        filterData={filterData}
      />
      {/*Update Donation */}
      <DonationFormModal
        open={open}
        onClose={handleCloseModalCallback}
        editData={editData}
        onSubmit={handleSaveDonation}
        formRef={formRef}
      />
      {/* New Donation Added */}
      <DonationFormModal
        open={isopenNew}
        onClose={handleCloseModalCallback}
        editData={editData}
        onSubmit={handleSaveDonation}
        formRef={formRef}
      />
      <SnackbarAlert feedback={feedback} onClose={handleCloseFeedbackCallback} />
    </Box>
  );
};
export default DonationManagement;
